export { Page } from './page.component'
